// 表单工具方法库
import fecha from 'fecha'
fecha.masks = {
  default: 'YYYY-MM-DD HH:mm:ss',
  shortDatetime: 'YYYY-MM-DD HH:mm',
  date: 'YYYY-MM-DD',
  time: 'HH:mm:ss',
  month: 'YYYY-MM',
  hour: 'YYYY-MM-DD HH',
  hm: 'HH:mm'
}

const GenderOptions = [
  // { key: 'SECRET', value: '保密' },
  { key: 'MALE', value: '男' },
  { key: 'FEMALE', value: '女' }
]

/**
 * 获取性别的选项
 */
export function getGenderOptions () {
  return GenderOptions
}

/**
 * 格式化性别
 * @param {*String or Nunber} code
 */
export function genderFormat (code) {
  switch (String(code)) {
    case '1':
      return '男'
    case '0':
      return '女'
  }
  for (let item of GenderOptions) {
    if (item.key === code) {
      return item.value
    }
  }
  return '保密'
}

/**
 * 将Date对象转换成unix timestamp
 */
export function dateToTimestamp (date) {
  return Math.round(date.getTime())
}
/**
 * 将unix timestamp转换成Date对象
 * @param {int} timestamp
 */
export function timestampToDate (timestamp) {
  return new Date(timestamp)
}
/**
 * 获取当前时间的unix timestamp
 */
export function getCurrentTimestamp () {
  return dateToTimestamp(new Date())
}
/**
 * Convert将指定的date值转换成date对象，可以接受timestamp、string或者date
 */

export function toDate (dateObject) {
  let date = null
  if (dateObject instanceof Date) {
    date = dateObject
  } else if (typeof dateObject === 'string') {
    date = new Date(dateObject)
  } else if (typeof dateObject === 'number') {
    if (dateObject === 0) {
      date = null
    } else {
      date = timestampToDate(dateObject)
    }
  }
  return date
}
/**
 * 将unix timestamp或者Date对象格式化成用于前端显示的字符串
 * 可选的格式:
 * 'default' - 'YYYY-MM-DD HH:mm:ss'
 * 'shortDatetime' - 'YYYY-MM-DD HH:mm'
 * 'date' - 'YYYY-MM-DD'
 * 'time' - 'HH:mm:ss'
 */
export function formatDateObject (dateObject, format = 'default') {
  if (!dateObject) {
    // console.warn('toData 方法必须接受一个有效且非空的参数')
    return ''
  }
  if (typeof dateObject === 'number' && dateObject.toString().length >= 16) {
    console.warn('toData 方法必须接受一个有效的时间戳')
    return ''
  }
  let date = toDate(dateObject)
  if (date == null) {
    return ''
  }
  return fecha.format(date, format)
}

/**
 * 格式化时间
 * @param {*Date} now
 */
export function formatDate (now) {
  return formatDateObject(now, 'date')
}

/**
 * 对对象进行深度拷贝
 * @param {*} data
 */
export function deepClone (data) {
  return JSON.parse(JSON.stringify(data))
}

// 上传/获取的时候，钱数乘以/除以100,当get为true时，则为获取，除以100
export function cashCount (val, get, number) {
  number = number || 0
  val = typeof val === 'number' ? val : parseFloat(val)
  let value
  if (get) {
    value = number ? (val / 100).toFixed(number) : val / 100
  } else {
    value = val * 100
  }
  return value
}
// 导出数据处理回调函数
export function dataExport (data) {
  let blob = new Blob([data.data])
  if ('download' in document.createElement('a')) {
    // 非IE下载
    const elink = document.createElement('a')
    elink.download = data.fileName
    elink.style.display = 'none'
    elink.href = URL.createObjectURL(blob)
    document.body.appendChild(elink)
    elink.click()
    URL.revokeObjectURL(elink.href) // 释放URL 对象
    document.body.removeChild(elink)
  } else {
    // IE10+下载
    navigator.msSaveBlob(blob, data.fileName)
  }
}
// 求数组中某个字段的最大值
export function maxValueMethod (arr, filed) {
  let maxValue = Math.max.apply(
    Math,
    arr.map(function (o) {
      return filed ? o[filed] : o
    })
  )
  return maxValue
}
// 求数组中某个字段的最小值
export function minValueMethod (arr, filed) {
  let minValue = Math.min.apply(
    Math,
    arr.map(function (o) {
      return filed ? o[filed] : o
    })
  )
  return minValue
}
// 判断空对象
export function isEmptyObject (obj) {
  for (var key in obj) {
    return false
  };
  return true
};
// 获取某时间戳所在日期的0点0分0秒
export function dateZero (date, type) {
  let data = date
  if (type === 'timestamp' || !type) {
    data = new Date(data)
  }
  data.setHours(0)
  data.setMinutes(0)
  data.setSeconds(0)
  data.setMilliseconds(0)
  if (type === 'timestamp' || !type) {
    data = data.getTime()
  }
  return data
}
/**
 * 根据生日计算年龄
 */
export function birthdayToAge (strBirthday) {
  if (!strBirthday) {
    return ''
  }
  var returnAge
  var strBirthdayArr = formatDate(strBirthday).split('-')
  var birthYear = strBirthdayArr[0]
  var birthMonth = strBirthdayArr[1]
  var birthDay = strBirthdayArr[2]

  var d = new Date()
  var nowYear = d.getFullYear()
  var nowMonth = d.getMonth() + 1
  var nowDay = d.getDate()

  if (nowYear === birthYear) {
    returnAge = 0// 同年 则为0岁
  } else {
    var ageDiff = nowYear - birthYear // 年之差
    if (ageDiff > 0) {
      if (nowMonth === birthMonth) {
        var dayDiff = nowDay - birthDay// 日之差
        if (dayDiff < 0) {
          returnAge = ageDiff - 1
        } else {
          returnAge = ageDiff
        }
      } else {
        var monthDiff = nowMonth - birthMonth// 月之差
        if (monthDiff < 0) {
          returnAge = ageDiff - 1
        } else {
          returnAge = ageDiff
        }
      }
    } else {
      returnAge = 0// 返回0 表示出生日期输入错误／晚于今天
    }
  }

  return returnAge// 返回周岁年龄
}
// 数组指定位置插入数据，但不改变原数组
export function arrInsert (arr, index, insertData) {
  let arrFirst
  let arrSecond
  for (let i = 0; i < arr.length; i++) {
    if (index === i) {
      arrFirst = arr.slice(0, i)
      arrSecond = arr.slice(i, arr.length)
    }
  }
  let insertArr = []
  // 将传入的数据（对象或者字符串）转化为数组
  if (typeof (insertData) === 'object' && Object.prototype.toString.call(insertData) === '[object Array]') {
    insertArr = insertData
  } else {
    insertArr.push(insertData)
  }
  let newArr = []
  newArr = insertArr.concat(arrFirst, arrSecond)
  console.log('newArr', newArr)
  return newArr
}
// 生成随机字符串(包含符号，字母和数字)
export function randomWord (randomFlag, min, max, data) {
  let str = ''
  let range = min
  let arr = data || ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9',
    'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l',
    'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z',
    'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L',
    'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z',
    '-', '.', '~', '!', '@', '#', '$', '%', '^', '&', '*', '(', ')', '_', ':', '<', '>', '?']

  if (randomFlag) {
    range = Math.round(Math.random() * (max - min)) + min// 任意长度
  }
  for (let i = 0; i < range; i++) {
    let pos = Math.round(Math.random() * (arr.length - 1))
    str += arr[pos]
  }
  return str
}
// 将字符串某几个位置的字符替换成符号或固定样式，如星号’*‘
// 第一个参数（str）为传入的字符串，第二个参数（afterLocation）为保留字符串尾部多少位的显示，第三个参数（beforeLocation）为保留字符串头部多少位的显示。
// 最后一个参数（symbol）为替换隐藏字符的符号。默认为”*“
export function strReplace (str, afterLocation, beforeLocation, symbol = '*') {
  if (beforeLocation) {
    return str.substr(0, beforeLocation) + Array(str.length).join(symbol) + str.substr(-afterLocation)
  } else {
    return Array(str.length).join(symbol) + str.substr(-afterLocation)
  }
}
// digit：位数
export function formatZero (number, digit) {
  return (Array(digit).join(0) + number).slice(-digit)
}
// 判断摸某个元素是否存在于数组对象中
export function existenceOfArrOrObj (arr, val) {
  var a
  arr.forEach(item => {
    if (item instanceof Object) {
      for (let i in item) {
        if (item[i] === val) {
          a = true
          return
        }
      }
    } else {
      if (item === val) {
        a = true
      }
    }
  })
  return a
}
// 去除字符串中所有空格/收尾空格
export function getDeleteSpace (str, isAll) {
  let result
  if (isAll) result = str.replace(/\s+/g, '')
  else result = str.trim()
  return result
}
